import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { Modal, Button } from 'antd';
import ReferToolbar from './ReferToolbar';
import { Row, Col, TreeTable } from '../basic';
// import { SearchTree } from '../meta';
import SearchTree from '../meta/SearchTree';
import ReferTable from './ReferTable';
import ReferPagination from './ReferPagination';
import env from '../../helpers/env';
let ConvenientQuery = null;

export default class ReferModal extends React.Component {
  constructor(props) {
    super(props);
    ConvenientQuery = require('../filter').default;
    this.state = {
      className: env.INTERACTIVE_MODE === 'touch' ? ' refer-modal-touch' : '',
      title: (this.props.title || '') + '参照',
      visible: this.props.visible,
      referType: this.props.referType,
      bodyHeight: 0,
      tableHeight: 0,
      modalWidth: 0,
    };
    this.__isElectronic = false;
    this.__isIpad = false;
    this.__isClientWidth = 0;
    this._clientHeight = 0;
    this._isTouch = env.INTERACTIVE_MODE === 'touch' ? true : false;
  }
  componentDidMount() {
    if (window.__isElectronic)
      this.__isElectronic = true;
    if (window.__isIpad) this.__isIpad = true;
    this.__isClientWidth = window.__isElectronicWidth;
    this.clientHeight = document.documentElement.clientHeight;
  }
  getModel() {
    return this.props.model || this.model;
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ visible: nextProps.visible });
    let model = nextProps.model;
    if (model) {
      const { referType } = nextProps;
      let modalHeight = this.clientHeight - this.clientHeight * 0.16;
      if(modalHeight < 340) modalHeight = 340;
      let bodyHeight = modalHeight - (this._isTouch ? 122 : 110);
      let tHeight;
      let modalWidth = modalHeight * (this.__isElectronic || this.__isIpad ? 1.4 : 1.6);
      if(modalWidth < 900) modalWidth = 900;
      switch (referType) {
        case 'Table':
          if (this._isTouch) {
            tHeight = bodyHeight - 60;
          } else {
            tHeight = bodyHeight - 44;
          }
          break;
        case 'TreeTable':
          if (this._isTouch) {
            tHeight = bodyHeight - 60;
          } else {
            tHeight = bodyHeight - 56;
          }
          break;
      }
      this.setState({ referType, bodyHeight, tableHeight: tHeight, modalWidth });
      if (!this.props.model) {
        model.un('filterHeightUpdate');
        model.on('filterHeightUpdate', () => {
          const toolbarHeight = findDOMNode(this.refs.ReferToolbar).clientHeight;
          let tableHeight = this.state.bodyHeight - toolbarHeight;
          this.props.model.get('table').execute('toolbarHeightUpdate', tableHeight);
        });
        if (typeof this.props.afterOkClick === 'function')
          model.on('afterOkClick', this.props.afterOkClick);
      }
    } else {
      if (this.props.cRefType) {
        model = this.getModel();
        if (!model) {
          let self = this;
          this.model = cb.loader.initRefer(this.props.cRefType, this.props.multiple || false, null, function (data) {
            self.setState({ referType: data.cTplType });
          }, this.props.afterOkClick);
        }
      }
    }
  }
  handleCancel() {
    this.setState({
      visible: false
    });
    if (this.props.close)
      this.props.close();
  }
  handleOk() {
    this.handleCancel();
    let model = this.getModel();
    if (model)
      model.okClick();
  }
  render() {
    const { referType, bodyHeight, tableHeight, modalWidth, title, visible } = this.state;
    const model = this.getModel();
    const key = model && model.getParams().refCode;
    let treeContent = '', cardContent = '', width = 0;
    let className = 'referModal ' + referType + this.state.className;
    if (referType == 'Tree') {
      treeContent = (<Col span={24} className="leftPanel">
        {/* <Row>
          <Col>
            <ReferToolbar model={model} />
          </Col>
        </Row> */}
        <Row colCount={2}>
          <Col span={1}>
            <SearchTree model={model.get('tree')} height={290} />
          </Col>
        </Row>
      </Col>);
    }
    else if (referType == 'TreeTable') {
      treeContent = (<div className="leftPanel">
        <SearchTree text={`${this.props.title}分类`} parentType="TreeTable" height={bodyHeight} model={model.get('tree')} />
      </div>);
      const filterId = model.getParams().filterId;
      if (this._isTouch)
        width = modalWidth - 210;
      else
        width = modalWidth - 201;
      cardContent = (<div className="rightPanel">
        <Row ref='ReferToolbar'>
          {filterId ? <ConvenientQuery model={model} cols={2} /> : null}
          <ReferToolbar model={model} filterId={filterId} />
        </Row>
        <Row>
          <ReferTable model={model.get('table')} width={width} maxRowCount={20} height={tableHeight} />
        </Row>
      </div>);
    }
    else if (referType == 'Table') {
      width = modalWidth;
      const filterId = model.getParams().filterId;
      cardContent = (<Col span={24} className="rightPanel">
        <Row ref='ReferToolbar'>
          {filterId ? <ConvenientQuery model={model} cols={2} /> : null}
          <ReferToolbar model={model} filterId={filterId} />
        </Row>
        <Row>
          <ReferTable model={model.get('table')} width={width} maxRowCount={20} height={tableHeight} />
        </Row>
      </Col>);
    }
    else if (referType === 'TreeList') {
      width = modalWidth;
      const filterId = model.getParams().filterId;
      cardContent = (<Col span={24} className="rightPanel">
        <Row ref='ReferToolbar'>
          {filterId ? <ConvenientQuery model={model} cols={2} /> : null}
          <ReferToolbar model={model} filterId={filterId} />
        </Row>
        <Row>
          <TreeTable model={model.get('tree')} width={width} maxRowCount={20} height={tableHeight} actionMeta={{ controls: [] }} />
        </Row>
      </Col>);
    }
    let modalContent = null;
    // if (this.__isElectronic && ((referType == 'TreeTable' || referType == 'Table'))) {
    //   let footerControl = (
    //     <div class="ant-modal-footer">
    //       <ReferPagination model={model.get('table')} />
    //       <Button onClick={e => this.handleCancel()} className="ant-btn-lg">取 消</Button>
    //       <Button onClick={e => this.handleOk()} type="primary" className="ant-btn-lg">确 定</Button>
    //     </div>
    //   )
    //   modalContent = (
    //     <Modal maskClosable={false} width={846} title={this.state.title} visible={this.state.visible}
    //       footer={footerControl}
    //       onOk={e => this.handleOk()} onCancel={e => this.handleCancel()} okText="确定" cancelText="取消"
    //       className={className}>
    //       <Row colCount={24}>
    //         {treeContent}
    //         {cardContent}
    //       </Row>
    //     </Modal>
    //   );
    // } else {
    modalContent = (
      <Modal key={key} maskClosable={false} width={modalWidth} title={title} visible={visible} onOk={e => this.handleOk()} onCancel={e => this.handleCancel()} okText="确定" cancelText="取消" className={className}>
        <Row colCount={24} id={key}>
          {treeContent}
          {cardContent}
        </Row>
      </Modal>
    );
    // }
    return modalContent;
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/refer/ReferModal.jsx